import { useMutation, useQueryClient } from '@tanstack/react-query';
import { removePrescriber } from '../../../../apis/clinics/requests';
import { useSnackbar } from 'notistack';

interface UseRemovePrescriberReturn {
  removePrescriber: (prescriberId: string) => Promise<void>;
  isLoading: boolean;
}

const useRemovePrescriber = (clinicId: string): UseRemovePrescriberReturn => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const { mutateAsync, isLoading } = useMutation(
    (prescriberId: string) => removePrescriber(clinicId, prescriberId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['prescribers', clinicId]);
        enqueueSnackbar('Prescriber has been removed', { variant: 'success' });
      },
      onError: () => {
        enqueueSnackbar('Failed to remove prescriber', { variant: 'error' });
      }
    }
  );

  return {
    removePrescriber: mutateAsync,
    isLoading
  };
};

export default useRemovePrescriber; 
